import type { TmsUserFeaturePermissions, TmsUserPagePermissions } from '@constants'

// need for active tab change in saga
export function permissionDeniedForUser(
  state: Store | Company,
  permission: TmsUserPagePermissions | TmsUserFeaturePermissions,
  isCompanyState = false
): boolean {
  if (isCompanyState) return (state as Company)?.[permission] ?? false
  return (state as Store).auth.company.data?.[permission] ?? false
}

// CompanyUserData
export function denyTransactionsPermission({
  deny_expense_permission = false,
  deny_nav_permission = false,
  deny_income_permission = false,
  deny_salary_permission = false,
  deny_tax_permission = false,
  deny_document_permission = false,
}: { [key: string]: unknown } & CompanyUserPermissions) {
  return (
    deny_expense_permission &&
    deny_nav_permission &&
    deny_income_permission &&
    deny_salary_permission &&
    deny_tax_permission &&
    deny_document_permission
  )
}
